module.exports = __webpack_public_path__ + "static/media/logo.f8ae0ee6.svg";